export class MatsuriError<T = Record<string, unknown>> extends Error {
  status?: number;

  private text: string;

  constructor(
    text: string,
    options: {
      status: number;
    },
  ) {
    const { status, ...rest } = options;
    /**
     * messageは後方互換性のためにこのような形式にしている
     */
    const message = `${status}: ${text}`;
    super(message, rest);
    this.name = "MatsuriError";
    this.status = status;
    this.text = text;
  }
  /**
   * NOTE: メソッドであってもErrorに存在しないプロパティは基本的にundefinedを許容させる。
   * これは実際はMatsuriErrorでないErrorが投げられたとしてもランタイムエラーを防げるような記述を強制させるために行う。
   * またMatsuriError|Errorが型としてはより正しいが、一方にしかないプロパティはインスタンスを確認しなければ利用できなくなってしまい冗長な記述を強いられてしまう。
   */
  parse: (<S = T>() => S | null) | undefined = <S = T>() => {
    try {
      return JSON.parse(this.text) as S;
    } catch {
      return null;
    }
  };
}
